module.exports = __webpack_public_path__ + "static/img_hakase01-b3b6c83a4b46cb7af6de5b1801ef5773.gif";